/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const MarketingActivitiesIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Marketing Activities',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M25.865 6.9a4.853 4.853 0 0 1-1.508 1.315l3.91 4.729a4.859 4.859 0 0 1 1.559-1.253Zm-16.85 8.869 4.268 3.386a4.843 4.843 0 0 1 1.312-1.512l-4.31-3.419a4.852 4.852 0 0 1-1.27 1.545Zm12.71 3.4a4.79 4.79 0 0 1 .584 1.928l5.623-2.473a4.809 4.809 0 0 1-.706-1.875ZM7.042 28.255A4.851 4.851 0 0 1 8.3 29.809l5.88-4.791a4.864 4.864 0 0 1-1.152-1.641ZM10.136 9.5a4.8 4.8 0 0 1 .657 1.938L18.2 6.98a4.8 4.8 0 0 1-.89-1.8Z"
    />
    <circle cx="4" cy="32" r="3.85" />
    <circle cx="17.5" cy="21.5" r="3.85" />
    <circle cx="22" cy="4" r="3.85" />
    <circle cx="6" cy="12" r="3.85" />
    <circle cx="32" cy="16" r="3.85" />
  </svg>`;
};
